import spacetime from 'spacetime';

export const setDateOrThrow = (
	date: Date | null,
	stateUpdatingFn: (value: React.SetStateAction<string>) => void
) => {
	if (date) stateUpdatingFn(spacetime(date).format('iso'));
	else throw new Error('invalid date entered through date and time picker');
};
